export default "__VITE_ASSET__CoaW8J5l__"